/**
 * useMemberCasesPort — port-factory hook returning a stable
 * {@link CasesReaderPort} for production composition (034 US1, T016).
 *
 * `Composition` calls this once at the root and passes the instance through
 * `PortsProvider` as the `memberCases` slot. Like `useMyDataPort` (and unlike
 * the demo-backed member ports), it constructs the REAL tRPC-backed reader
 * (`TrpcCasesReader` over `member.cases.list`) — the member's cookie session
 * authenticates the same-origin request, so no bearer source is wired.
 *
 * Test harnesses do NOT call this factory — the `memberCases` slot stays
 * omitted by default so the missing-port stub semantics hold; tests that
 * exercise the surface pass a fixture port explicitly.
 */

import { useState } from 'react';
import type { CasesReaderPort } from '../member-cases/CasesReaderPort.js';
import { TrpcCasesReader } from '../member-cases/TrpcCasesReader.js';
import { createWebTrpcClient } from '../trpc/client.js';

export function useMemberCasesPort(): CasesReaderPort {
  const [port] = useState<CasesReaderPort>(() => new TrpcCasesReader(createWebTrpcClient()));
  return port;
}
